import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IRouteMap } from 'lib-core-shared';
import { productRouteMap } from '../../app-routing.module';


@Component({
  selector: 'app-home',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  public searchRoute: IRouteMap | undefined;

  constructor(private router: Router) {

  }
  ngOnInit(): void {
    if (productRouteMap.children?.length) {
      productRouteMap.children.filter(x => x.name = 'search').forEach(x =>  this.searchRoute = x);
    }
  }
  title = 'product-management';

  goto() {
    if (this.searchRoute) 
    this.router.navigate([this.searchRoute.fullRouteName, {relativeTo: this.router}]);
  }
}
